import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import { environment } from '@env/environment';


@Injectable({ providedIn: 'root' })
export class SystemInfoService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getSystemInfo(): any {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/nameplate`);
  }  
  
  restoreSystem(): any {
    return this.httpClient.put(`${environment.SYSTEMINFO_API_ENDPOINT}/restore`,{});
  }

  updateSystemInfo(): any {
    return this.httpClient.put(`${environment.SYSTEMINFO_API_ENDPOINT}/state`,{});
  }    

  getSystemValidityInfo(): any {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/validity`);
  }

  // locked when checksums/counters are invalid (OIML) or the system is out of calibration
  getLockedState(): any {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/locked-state`);
  }

  getServerInfo(): any {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/server-info`);
  }

  updateServerConfig(payload: { systemId?: string, tag?: string }): any {
    return this.httpClient.put(`${environment.SYSTEMINFO_API_ENDPOINT}/server-config`, payload);
  }

  getRebootHistory(): any {
    return this.httpClient.get(`${environment.SYSTEMINFO_API_ENDPOINT}/reboot-history`);
  }

}

